/* Values match the values from the server. */
export const PassState = {
  Pass: 'PASS',
  Fail: 'FAIL',
  NoRx: 'NO-RX',
  Na: 'NA',
  Condition: 'CONDITION',
  Override: 'OVERRIDE',
  Indeterminate: 'INDETERMINATE',
  Exception: 'EXCEPTION',
  Verified: 'VERIFIED'
} as const;

export type PassState = ValueOf<typeof PassState>;